import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getTransshipmentTransportationModeList(params) {
  return request({
    url: URL.mdm.basicData.transshipmentTransportationMode,
    method: 'get',
    params
  })
}

export function getTransportationModeAll() {
  return request({
    url: URL.mdm.basicData.transportationModeAll,
    method: 'get'
  })
}

export function saveTransshipmentTransportationMode(data) {
  return request({
    url: URL.mdm.basicData.transshipmentTransportationMode,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function deleteTransshipmentTransportationMode(data) {
  return request({
    url: URL.mdm.basicData.transshipmentTransportationMode,
    method: 'delete',
    data
  })
}
